var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// tslint:disable:max-func-body-length
import * as Long from "long";
import { utilTime } from "../../utils/utilTime";
import { TypeActionCoopInfo, } from "./actionCoop";
import { IdCoopCategory } from "./IdCoopCategory";
export var initial = {
    buffs: [],
    contributionInfo: undefined,
    coop: undefined,
    coopProjectAccessTime: 0,
    eventNotices: [],
    firstTab: undefined,
    found: {
        selectedLanguage: undefined,
    },
    help: {
        cooldownEndTime: undefined,
        cooldownTime: undefined,
        points: [],
        projectPoints: undefined,
    },
    invite: {
        activeInvite: undefined,
        inviteResponse: undefined,
        invitingCoop: undefined,
    },
    member: [],
    project: undefined,
    projectEndTime: undefined,
    projectTypeInfo: undefined,
    search: {
        coops: [],
        selectedCoop: { coop: undefined, member: undefined },
        selectedLanguage: undefined,
    },
    selectedProjectDifficulty: undefined,
    selectedProjectTypeId: -1,
};
export var reducerCoopInfoReceived = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionCoopInfo.Received:
            if (action.coop != undefined) {
                return __assign({}, state, { coop: action.coop, member: action.member, project: action.project, projectEndTime: action.project
                        ? getProjectEndTime(action.project.remainingTime)
                        : undefined });
            }
            break;
        case TypeActionCoopInfo.SetProjectAccessTime:
            if (action.time !== undefined) {
                return __assign({}, state, { coopProjectAccessTime: action.time });
            }
            break;
        case TypeActionCoopInfo.ResetProject:
            return __assign({}, state, { contributionInfo: undefined, project: undefined });
        case TypeActionCoopInfo.LeaveCoopSuccessfully:
            return __assign({}, state, { coop: undefined, member: [], project: undefined, projectEndTime: undefined });
        case TypeActionCoopInfo.JoinableCoopListResponse:
            return __assign({}, state, { search: __assign({}, state.search, { coops: action.coops }) });
        case TypeActionCoopInfo.SetFilterLanguage:
            return __assign({}, state, { search: __assign({}, state.search, { selectedLanguage: action.language }) });
        case TypeActionCoopInfo.SetFoundLanguage:
            return __assign({}, state, { found: __assign({}, state.found, { selectedLanguage: action.language }) });
        case TypeActionCoopInfo.SearchResponse:
            return __assign({}, state, { search: __assign({}, state.search, { selectedCoop: {
                        coop: action.coop,
                        member: action.member,
                    } }) });
        case TypeActionCoopInfo.ClearSelectedCoop:
            return __assign({}, state, { search: __assign({}, state.search, { selectedCoop: { coop: undefined, member: undefined } }) });
        case TypeActionCoopInfo.InviteInfoReceived:
            return __assign({}, state, { invite: __assign({}, state.invite, { activeInvite: action.activeInvite, invitingCoop: action.invitingCoop }) });
        case TypeActionCoopInfo.MemberResponse:
            var nextState = createMemberResponseState(state, action);
            return nextState ? nextState : state;
        case TypeActionCoopInfo.JoinableCoopSelect:
            return createJoinableCoopSelectState(state, action);
        case TypeActionCoopInfo.KickMemberResponse:
        case TypeActionCoopInfo.AssignRoleResponse:
            if (action.coop && action.member) {
                return __assign({}, state, { coop: action.coop, member: action.member });
            }
            break;
        case TypeActionCoopInfo.CoopPointsInfoResponse:
            var cooldownTime = action.cooldownTime;
            return __assign({}, state, { help: {
                    cooldownEndTime: cooldownTime ? utilTime.timestamp(cooldownTime) : undefined,
                    cooldownTime: action.cooldownTime,
                    points: action.points || [],
                    projectPoints: action.projectPoints,
                } });
        case TypeActionCoopInfo.SendCoopPointsResponse:
            if (action.cooldownTime) {
                return __assign({}, state, { help: __assign({}, state.help, { cooldownEndTime: utilTime.timestamp(action.cooldownTime), cooldownTime: action.cooldownTime }) });
            }
            break;
        case TypeActionCoopInfo.CollectCoopPointsResponse:
            return __assign({}, state, { help: __assign({}, state.help, { points: [], projectPoints: undefined }) });
        case TypeActionCoopInfo.SelectCoopProjectType:
            return __assign({}, state, { selectedProjectTypeId: action.coopProjectTypeId });
        case TypeActionCoopInfo.SelectCoopProjectDifficulty:
            return __assign({}, state, { selectedProjectDifficulty: action.difficultyLevel });
        case TypeActionCoopInfo.StartCoopProjectSuccess:
            return __assign({}, state, { contributionInfo: undefined, project: action.project, projectEndTime: action.project
                    ? getProjectEndTime(action.project.remainingTime)
                    : undefined });
        case TypeActionCoopInfo.StopCoopProjectSuccess:
            return __assign({}, state, { project: undefined, projectEndTime: undefined });
        case TypeActionCoopInfo.ProjectInfoResponse:
            return __assign({}, state, { contributionInfo: action.points || [] });
        case TypeActionCoopInfo.ProjectInfoClear:
            return __assign({}, state, { contributionInfo: undefined });
        case TypeActionCoopInfo.RequestCoopProjectTypeInfoSuccess:
            return __assign({}, state, { projectTypeInfo: action.projectTypeInfo });
        case TypeActionCoopInfo.ProjectInfoReceived:
            var project = action.project;
            var projectEndTime = getProjectEndTime(action.project.remainingTime);
            return __assign({}, state, { contributionInfo: action.points || [], project: project,
                projectEndTime: projectEndTime });
        case TypeActionCoopInfo.InvitePlayerResponse:
            return __assign({}, state, { invite: __assign({}, state.invite, { inviteResponse: action.invite }) });
        case TypeActionCoopInfo.ClearInvitePlayerResponse:
            return __assign({}, state, { invite: __assign({}, state.invite, { inviteResponse: undefined }) });
        case TypeActionCoopInfo.EditCoopSuccess: {
            return __assign({}, state, { coop: action.coop, project: action.project, projectEndTime: action.project
                    ? getProjectEndTime(action.project.remainingTime)
                    : undefined });
        }
        case TypeActionCoopInfo.GetCoopEventNoticesResponse:
            return __assign({}, state, { eventNotices: action.messageParams.messageParams });
        case TypeActionCoopInfo.AddXp: {
            if (state.coop !== undefined) {
                var prevXp = state.coop.xp || Long.ZERO;
                return __assign({}, state, { coop: __assign({}, state.coop, { xp: action.xp.add(prevXp) }) });
            }
            return state;
        }
        case TypeActionCoopInfo.SetFirstTab:
            return __assign({}, state, { firstTab: action.tabId });
        case TypeActionCoopInfo.AddSearchCoopMembers: {
            return __assign({}, state, { search: __assign({}, state.search, { selectedCoop: __assign({}, state.search.selectedCoop, { member: action.member }) }) });
        }
        case TypeActionCoopInfo.CoopBuffInfoReceived: {
            var buffs = action.buff != undefined
                ? action.buff.map(function (element) { return (__assign({}, element, { id: element.id.valueOf() })); })
                : [];
            return __assign({}, state, { buffs: buffs });
        }
    }
    return state;
};
var createMemberResponseState = function (state, action) {
    var nextState;
    if (action.member && action.member.length > 0) {
        if (action.tabId === IdCoopCategory.CoopSearch) {
            var coop = action.coop ? action.coop : state.search.selectedCoop.coop;
            return __assign({}, state, { search: __assign({}, state.search, { selectedCoop: { coop: coop, member: action.member } }) });
        }
        nextState = __assign({}, state, { member: action.member });
    }
    return nextState;
};
var createJoinableCoopSelectState = function (state, action) {
    var coop = action.coop ? action.coop : state.search.selectedCoop.coop;
    var member = action.member ? action.member : state.search.selectedCoop.member;
    return __assign({}, state, { search: __assign({}, state.search, { selectedCoop: { coop: coop, member: member } }) });
};
var getProjectEndTime = function (remainingSeconds) {
    return remainingSeconds ? utilTime.timestamp(remainingSeconds) : undefined;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/reducerCoopInfo.ts
// module id = 2522
// module chunks = 3